import Vue from 'vue';
import VueRouter from 'vue-router';
import RouterPrefetch from 'vue-router-prefetch'
import store from "./store";
import App from './App.vue';

// plugins
import FlagIcon from 'vue-flag-icon';
import VeeValidate from "vee-validate";
import DashboardPlugin from './plugins/dashboard-plugin';
import Loading from 'vue-loading-overlay';
import lodash from 'lodash'
import VueLodash from 'vue-lodash';
import VueHtml2Canvas from 'vue-html2canvas';
import CheckboxRadio from 'vue-checkbox-radio';
import VueCurrencyInput from 'vue-currency-input';
import i18n from './i18n';

import Chart from 'chart.js';

// Vee-validate original dictionaries
import enValidations from "vee-validate/dist/locale/en";
import frValidations from "vee-validate/dist/locale/fr";

// services
import ApiService from '@/services/api.service.js';
import {TokenService} from '@/services';
import {LocalizationService} from '@/services';

// router setup
import router from './routes/router';

// API and token setup, set the base URL of the API
ApiService.init(process.env.VUE_APP_ROOT_API);

// // If token exists set header
if (TokenService.getToken()) {
  ApiService.setHeader()
}

// Validator
Vue.use(VeeValidate, {
  i18n,
  i18nRootKey: 'validations', // customize the root path for validation messages.
  fieldsBagName: 'veeFields',
  dictionary: {
    en: enValidations,
    fr: frValidations
  },
});

Vue.use(DashboardPlugin);
Vue.use(FlagIcon);
Vue.use(VueRouter);
Vue.use(VueHtml2Canvas);
Vue.use(CheckboxRadio);
Vue.use(VueCurrencyInput);
Vue.use(VueLodash, lodash);
Vue.use(RouterPrefetch);
Vue.use(Loading, {
  color: 'green',
  loader: 'bars',
  width: 80,
  height: 80,
  backgroundColor: '#ffffff',
  opacity: 0.5,
  zIndex: 9999,
});

Object.defineProperty(Vue.prototype, '_', { value: lodash });

Chart.defaults.global.legend.display = false;

let initializations = [];
initializations.push(LocalizationService.init());

// load when all completed
let loader = Vue.$loading.show();

Promise.all(initializations).then(function () {
  loader.hide();

  store.dispatch('Localization/setLanguages', LocalizationService.languages);

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    render: h => h(App),
    router,
    store,
    i18n
  });

});
